import * as GlobalModules from './global';
import * as S2Blocks from '../blocks/index';

const ModulesAndBlocks = { ...GlobalModules, ...S2Blocks };

console.log('app.js');

document.addEventListener('DOMContentLoaded', () => {
	for (const key in ModulesAndBlocks) {
		// Initialize modules/blocks on the frontend (i.e. when window.acf is undefined)
		if (Object.hasOwnProperty.call(ModulesAndBlocks, key) && !window.acf)
			ModulesAndBlocks[key].init();

		// Make sure blocks JS render properly in the editor (cf. https://www.advancedcustomfields.com/resources/acf_register_block_type/)
		if (window.acf && Object.hasOwnProperty.call(S2Blocks, key))
			window.acf.addAction(
				`render_block_preview/type=${S2Blocks[key].name}`,
				S2Blocks[key].init
			);
	}
});